import React, { FC, KeyboardEvent } from 'react';
import { Grid, Typography } from '@material-ui/core';

import { ValidatedTextField } from 'components';

const EmailOptions: FC = () => {
  function handleKeyPress(event: KeyboardEvent<HTMLDivElement>) {
    if (event.key === '@' || event.key === ' ') {
      event.preventDefault();
    }
  }

  return (
    <Grid container>
      <Grid item xs={3}>
        <Typography variant="subtitle2">Email Options</Typography>
      </Grid>
      <Grid item xs>
        <Grid container spacing={5}>
          <Grid item xs={4}>
            <ValidatedTextField
              persistLabel
              TextFieldProps={{ margin: 'none' }}
              name="email_sending_domain"
              i18nKey="clientSuccess:emailSendingDomain"
              onKeyPress={handleKeyPress}
            />
          </Grid>
          <Grid item xs>
            <ValidatedTextField
              persistLabel
              TextFieldProps={{ margin: 'none' }}
              name="email_from_address"
              i18nKey="clientSuccess:emailFromAddress"
            />
          </Grid>
        </Grid>
        <Grid container spacing={5}>
          <Grid item xs>
            <ValidatedTextField
              persistLabel
              TextFieldProps={{ margin: 'none' }}
              name="email_address"
              i18nKey="clientSuccess:emailAddress"
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EmailOptions;
